import { s } from '@/theme/tokens';
import { tableTagChipSx } from '../tags/tagChipStyles';
import type { SxProps, Theme } from '@/ui/primitives';

export const tagsFilterFieldChipMaxWidth = 'min(320px, 100%)';

export const tagsFilterOptionCheckboxSx = {
  p: s('none'),
  m: s('none'),
  mr: s('xs'),
  pointerEvents: 'none',
} as const satisfies SxProps<Theme>;

export const tagsFilterOptionChipSx = {
  ...tableTagChipSx,
  justifySelf: 'flex-start',
  ml: s('xs'),
  maxWidth: tagsFilterFieldChipMaxWidth,
  width: 'fit-content',
  '& .MuiChip-label .MuiTypography-root': {
    color: 'inherit',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
} as const satisfies SxProps<Theme>;

export const tagsFilterSelectedChipSx = {
  ...tableTagChipSx,
  flex: '0 1 auto',
  maxWidth: tagsFilterFieldChipMaxWidth,
  width: 'fit-content',
  '& .MuiChip-label': {
    color: 'inherit',
    display: 'inline-flex',
    maxWidth: '100%',
    textOverflow: 'clip',
  },
  '& .MuiChip-label .MuiTypography-root': {
    color: 'inherit',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
} as const satisfies SxProps<Theme>;
